module.exports = __webpack_public_path__ + "img/pr-4.0bb61d41.png";